module.exports = __webpack_public_path__ + "img/logo.911fadee.png";